module.exports = __webpack_public_path__ + "videos/3d-painting_jp.5cea5aa.mp4";